import React from 'react';
import { LabelledMultiLangInputProps, MultiLangInput } from '@carlito/dashboard-ui';
import { CustomDateInputField } from './CustomDateInputField';

type Props = LabelledMultiLangInputProps & {
  enabledKeyboard?: boolean;
};

export function DateInputWithKeyboard({ enabledKeyboard, ...props }: Props) {
  if (enabledKeyboard) return <CustomDateInputField {...props} />;
  return <MultiLangInput {...props} />;
}
